export default __webpack_public_path__ + "static/swash-3c42841d49ebbbd5eec6a891a80895df.svg";